import React, { useState } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config.json";

const DocumentUploadModal = ({ show, onClose, onSuccess }) => {
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async () => {
    if (!title.trim()) {
      setError("Document title is required");
      return;
    }

    if (!file) {
      setError("Please select a file");
      return;
    }

    setLoading(true);
    setError(null);

    const fd = new FormData();
    fd.append("file", file);
    fd.append("documentType", "ESG_DOCUMENT_LIBRARY");
    // 🔥 THIS IS THE KEY FIX
    fd.append("documentMetadata[name]", title);

    fd.append("addToReporting", "false");
    fd.append("shouldParseDocument", "false");

    const { isSuccess } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}documents/uplaodAndSave`,
      {},
      fd,
      "POST"
    );

    setLoading(false);

    if (!isSuccess) {
      setError("Failed to upload document");
      return;
    }

    onSuccess();
    onClose();
  };

  return (
    <Modal show={show} centered backdrop="static" onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Upload ESG Document</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <Form.Group className="mb-3">
          <Form.Label>Document Title *</Form.Label>
          <Form.Control
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            disabled={loading}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Select File *</Form.Label>
          <Form.Control
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
            disabled={loading}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={submit} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Upload & Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DocumentUploadModal;
